import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

export const CHECKOUT_FLOW_STEPS = [
    { id: "cart", label: " Carro", to: "/carro", icon: "pi pi-shopping-cart" },
    { id: "checkout", label: "Checkout", icon: "pi pi-credit-card" },
    { id: "result", label: "Resultado", icon: "pi pi-check-circle" },
];

export const STEP_STATE = { checkout: 1, success: 2, rejected: 2 };

const styles = {
    container: {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: 8,
        marginBottom: 12,
    },
    step: (isActive) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        padding: "6px 8px",
        border: `1px solid ${isActive ? "#93c5fd" : "#dbe1ea"}`,
        borderRadius: 8,
        background: "#ffffff",
        color: isActive ? "#0f172a" : "#64748b",
        textDecoration: "none",
        transition: "border-color 0.2s",
    }),
    circle: (isActive, isCompleted) => ({
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 22,
        height: 22,
        borderRadius: "50%",
        background: isActive || isCompleted ? "#1d4ed8" : "#e5e7eb",
        color: "#ffffff",
        fontSize: 11,
        fontWeight: 700,
        flexShrink: 0,
    }),
    label: (isActive) => ({
        fontSize: 12,
        fontWeight: 600,
        color: isActive ? "#0f172a" : "#64748b",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    }),
};

const CheckoutFlowStepper = ({ steps = CHECKOUT_FLOW_STEPS, currentStepIndex = 0, className = "" }) => {
    const [compact, setCompact] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const check = () => {
            if (ref.current) {
                const w = ref.current.offsetWidth;
                setCompact(w < 360);
            }
        };
        check();
        const ro = new ResizeObserver(check);
        if (ref.current) ro.observe(ref.current);
        return () => ro.disconnect();
    }, []);

    return (
        <nav ref={ref} style={styles.container} className={className}>
            {steps.map((item, index) => {
                const isActive = index === currentStepIndex;
                const isCompleted = index < currentStepIndex;

                const content = (
                    <>
                        <span style={styles.circle(isActive, isCompleted)}>
                            {compact ? <i className={item.icon} style={{ fontSize: 12 }} /> : index + 1}
                        </span>
                        {!compact && <span style={styles.label(isActive)}>{item.label}</span>}
                    </>
                );

                return item.to ? (
                    <Link
                        key={item.id}
                        to={item.to}
                        style={styles.step(isActive)}
                    >
                        {content}
                    </Link>
                ) : (
                    <div
                        key={item.id}
                        style={styles.step(isActive)}
                    >
                        {content}
                    </div>
                );
            })}
        </nav>
    );
};

export default CheckoutFlowStepper;
